import React from "react";
import styled from "styled-components";

const Grid = styled.div`
  display: grid;
  grid-gap: 0 1em;
  grid-template-columns: repeat(${props => props.grid}, 1fr);
`;

const Button = styled.div`
  line-height: 42px;
  padding: 0 36px;
  color: white;
  text-transform: uppercase;
  font-size: 12px;
  border-radius: 0;
  background: #4b5f78;
  font-family: "Roboto", sans-serif;
  float: right;
  border-radius: 8px;
`;

export default function ContactForm() {
  return (
    <section className="about-area section-gap">
      <div className="container">
        <div className="text-center mb-70">
          <h1>Get In Touch</h1>
        </div>
        <form
          className="form-area contact-form text-right"
          id="myForm"
          // action="https://colorlib.com/preview/theme/educature/mail.php"
          method="post"
        >
          <Grid grid={1}>
            <div className="form-group textarea">
              <textarea
                className="common-textarea form-control"
                rows="6"
                name="message"
                placeholder="Enter Messege"
                required=""
                data-cf-modified-0667f956f0e5f0ee5e5c7981-=""
              />
            </div>
          </Grid>
          <Grid grid={3}>
            <div className="form-group input-name">
              <input
                name="name"
                placeholder="Enter your name"
                className="common-input mb-20 form-control"
                required=""
                type="text"
                data-cf-modified-0667f956f0e5f0ee5e5c7981-=""
              />
            </div>
            <div className="form-group input-email">
              <input
                name="email"
                placeholder="Enter email address"
                pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,63}$"
                className="common-input mb-20 form-control"
                required=""
                type="email"
                data-cf-modified-0667f956f0e5f0ee5e5c7981-=""
              />
            </div>
            <div className="submit-button">
              <Button className="submit-message">Send Message</Button>
            </div>
          </Grid>
        </form>
      </div>
    </section>
  );
}
